import { useState } from 'react';

import { Button } from 'primereact/button';
import { Tooltip } from 'primereact/tooltip';

import { useLocale } from 'context/locale-context';
import { useSettings } from 'context/settings-context';

import { downloadBlobURL } from 'shared/helpers/openBlobURL';

import { useAPI } from '../../../context/api-context';

const ExportPersonTable = () => {
  const { getLocaleOption } = useLocale();
  const { somethingWentWrongToast } = useSettings();

  const [exporting, setExporting] = useState(false);
  const { fetchFileAPI } = useAPI();

  const exportHandler = async () => {
    if (!exporting) {
      setExporting(true);

      const blob: Blob | undefined = await fetchFileAPI('/users/_person_xls/');

      if (blob) {
        const fileName: string = `${new Date().toLocaleDateString().replace('/', '_')}_${getLocaleOption('users')}_person.xlsx`;
        downloadBlobURL(blob, fileName);
      } else {
        somethingWentWrongToast();
      }

      setExporting(false);
    }
  };

  return (
    <div className='export-persons'>
      <Button
        type='button'
        icon='pi pi-users'
        loading={exporting}
        className='p-button-success mr-2'
        data-pr-tooltip='Export Person Data'
        onClick={exportHandler}
      />
      <Tooltip target='.export-persons>button' position='bottom' />
    </div>
  );
};

export default ExportPersonTable;
